import SubscriptionInterval from "@mapmycustomers/shared/enum/SubscriptionInterval";
import Plan from "@mapmycustomers/shared/types/Plan";
import { Range } from "@mapmycustomers/shared/types/plans/Range";
import Tier from "@mapmycustomers/shared/types/plans/Tier";

import { isPurchasableTier } from "@app/util/plans/findPlanTier";

export const isInRange = ([from, to]: Range, value: number) =>
  value >= from && value <= (to ?? Number.POSITIVE_INFINITY);

export const findTierByIntervalAndLicenses = (
  tiers: Tier[],
  interval: SubscriptionInterval,
  licenses: number
) => {
  let tier: Tier | undefined;
  const possibleTiers = tiers.filter(
    ({ isTrial, licenseLimit }) => isInRange(licenseLimit, licenses) && !isTrial
  );
  if (possibleTiers.length === 1) {
    tier = possibleTiers[0];
  } else {
    tier = possibleTiers.find((tier) => tier.interval === interval && !tier.isTrial);
    if (!tier && interval === SubscriptionInterval.MONTHLY) {
      // try to find the best matching annual tier then
      tier = possibleTiers.find(
        (tier) => tier.interval === SubscriptionInterval.ANNUAL && !tier.isTrial
      );
    }
  }
  return tier;
};

export const convertPlanToTier = (plan: Plan): Tier => ({
  id: plan.id,
  customFieldsLimit: plan.customFieldsLimit,
  interval: plan.interval === 1 ? SubscriptionInterval.MONTHLY : SubscriptionInterval.ANNUAL,
  isTrial: plan.trialing,
  licenseLimit: plan.metaData?.licenseLimit ?? [0],
  name: plan.name,
  price: { currency: "USD", value: plan.price },
  quantity: plan.quantity,
  recordsLimit: plan.recordsLimit,
  type: plan.type,
  upsellOrder: plan.upsellOrder,
});

export const convertToTiers = (plans: Plan[]): Tier[] =>
  plans.filter(isPurchasableTier).map(convertPlanToTier);
